// **Un error de regla es un objeto, y React no pinta objetos.**
//
// El backend devuelve sus reglas como `{"detail": {"code": …, "message": …}}`
// —está escrito así en INV-110 y lo usan todos los módulos— y los reducers
// guardaban `payload?.detail` tal cual en `errorMessage`. En cuanto una venta
// chocaba con una regla (sin disponible, lote ocupado, empaque sin
// existencia), `toast.error(objeto)` intentaba renderizarlo y React tiraba
// «Objects are not valid as a React child (found: object with keys {code,
// message})», que **desmonta el árbol entero**: la pantalla desaparece y lo
// único que queda es el overlay rojo.
//
// Es el mismo error que ya había pasado con `resultado.aviso` en el cuadro de
// sugerir precio. La diferencia es que acá estaba repetido en 56 lugares, así
// que la corrección es una función y no 56 ternarios.
//
// `detail` llega de tres formas y las tres se contemplan:
//   * texto      → el `HTTPException(detail="…")` de siempre;
//   * objeto     → la regla, con su `code` y su `message`;
//   * lista      → el 422 de Pydantic, que trae un error por campo.

// **Solo sale texto.** Tomar `x.message` a ciegas era volver a lo mismo: si
// ese campo trae un objeto —pasa con los errores anidados de algunas
// librerías— el objeto llegaba igual a React. Lo encontró la prueba.
const soloTexto = (v) => (typeof v === 'string' && v.trim() ? v : '');

const deUno = (x) => {
    if (typeof x === 'string') return x;
    if (!x || typeof x !== 'object') return '';
    // Pydantic: `{loc: [...], msg: "...", type: "..."}`.
    if (soloTexto(x.msg)) {
        const campo = Array.isArray(x.loc)
            ? x.loc.filter(p => p !== 'body').map(String).join('.') : '';
        return campo ? `${campo}: ${x.msg}` : x.msg;
    }
    return soloTexto(x.message) || soloTexto(x.detail) || '';
};

// Lo que el servidor quiso decir, siempre como texto.
export const textoDeDetalle = (payload, porDefecto = 'No se pudo completar la operación') => {
    const d = payload?.detail ?? payload;
    const texto = Array.isArray(d) ? d.map(deUno).filter(Boolean).join(' · ') : deUno(d);
    // El `porDefecto` también se pasa por el filtro: si alguien lo llama con un
    // objeto, la pantalla no se puede caer por eso.
    return texto || soloTexto(porDefecto) || 'No se pudo completar la operación';
};

// Lo mismo desde el `catch` de un thunk, donde todavía se tiene el error de axios.
export const mensajeDeError = (error, porDefecto) =>
    textoDeDetalle(error?.response?.data, porDefecto);

// El código de la regla, para cuando la pantalla decide algo con él.
export const codigoDeError = (payload) => {
    const d = payload?.detail ?? payload;
    return (d && typeof d === 'object' && !Array.isArray(d) && d.code) || null;
};
